import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { Login } from '../../models/request/login';
import { CONSTANTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class LoginService extends ApiService {

  public doLogin(login: Login){
    return this.post(CONSTANTS.API.LOGIN, login);
  }

  public logout() {
    return this.get(CONSTANTS.API.LOGOUT);
  }
}
